
import { FormPage } from "../../types/form";

export const page1Config: FormPage = {
  page: 1,
  elements: [
    {
      id: "teacher_id_name",
      type: "teacher_search",
      label: "formFields.page1.teacherSearchLabel",
      name: "teacher_id_name_display",
      required: true,
      description: "formFields.page1.teacherSearchDesc",
      targetField: "teacher_id"
    },
    {
      id: "teacher_id_field",
      type: "text",
      label: "formFields.page1.teacherIdLabel",
      name: "teacher_id",
      required: true,
      readOnly: true,
      description: "formFields.page1.teacherIdDesc"
    },
    {
      id: "terms_instruction",
      type: "rich_text_instruction",
      text: "formFields.page1.termsRichText"
    },
    {
      id: "terms_agreement",
      type: "checkbox",
      label: "formFields.page1.termsAgreementLabel",
      name: "agreed_to_terms",
      required: true,
      options: [
        { value: true, label: "formFields.page1.termsAgreementOption" }
      ]
    }
  ]
};
